export default "__VITE_ASSET__21a5775a__"